import { notifications } from "@mantine/notifications";
import axios, { isAxiosError } from "axios";

export const httpClient = axios.create({
  baseURL: window.__ENV__.VITE_API_URL ?? import.meta.env.VITE_API_URL,
});

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (isAxiosError(error)) {
      if (error.response?.data instanceof Blob) {
        const text = await error.response.data.text();

        try {
          const parsed = JSON.parse(text);
          notifications.show({
            color: "red",
            message: parsed.message || "Произошла ошибка при скачивании",
          });
        } catch {
          notifications.show({
            color: "red",
            message: text,
          });
        }
      } else {
        notifications.show({
          color: "red",
          message: error.response?.data.message ?? "Неизвестная ошибка",
        });
      }
    } else {
    }

    throw error;
  }
);
